import React, { useState } from "react";
import { Collapse } from "antd";
import TourContactListForm from "../../pages/EditForm/TourContactListForm";
import "./sectionForms.css";

const { Panel } = Collapse;

interface TourContactListSectionProps {
    form: any;
    initialValues?: any;
}

const config = {
    rules: [
        {
            required: true,
            message: "此項為必填。",
        },
    ],
};

export default function TourContactListSection({ form, initialValues }: TourContactListSectionProps) {
    const [transferGuideState, setTransferGuideState] = useState<string>('empty');
    const [tourStaffState, setTourStaffState] = useState<string>('empty');

    return (
        <Collapse defaultActiveKey={["1"]}>
            <Panel header={<h3>第 III 部分：內地旅行代理商／內地非旅行代理商單位、接待導遊等資料</h3>} key="1" forceRender>
                <div className="booking-section">
                    <TourContactListForm
                        form={form}
                        config={config}
                        isFirstRegistration={true}
                        hasTravelAgent={"內地旅行代理商／內地非旅行代理商單位"}
                        transferGuideState={transferGuideState}
                        setTransferGuideState={setTransferGuideState}
                        tourStaffState={tourStaffState}
                        setTourStaffState={setTourStaffState}
                    />
                </div>
            </Panel>
        </Collapse>
    );
}
